import type { MenuItem } from 'primeng/api';

/** Base path for the lazy-loaded BrightNav admin feature (matches `brightnav.routes.ts`). */
export const BRIGHTNAV_ADMIN_BASE_PATH = '/brightnav/admin';

/**
 * Builds PrimeNG `MenuItem` entries for `p-breadcrumb` from the current router URL.
 *
 * @param routerUrl Full URL string from {@link Router.url} (path + optional query; query is ignored).
 * @returns At least one item; the last item has no `routerLink` when it denotes the active page.
 */
export function buildAdminBreadcrumbs(routerUrl: string): MenuItem[] {
  const path = (routerUrl.split('?')[0] ?? '/').replace(/\/+$/, '') || '/';
  const base = BRIGHTNAV_ADMIN_BASE_PATH;

  if (!path.startsWith(base)) {
    return [{ label: 'Administration', routerLink: [base] }];
  }

  const rest = path.slice(base.length).replace(/^\/+|\/+$/g, '');

  if (!rest) {
    return [{ label: 'Administration' }];
  }

  const administration: MenuItem = { label: 'Administration', routerLink: [base] };

  if (rest === 'suggestions') {
    return [administration, { label: 'Suggestion chips' }];
  }

  const label = rest
    .split('/')
    .filter(Boolean)
    .map((s) => s.replace(/[-_]/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()))
    .join(' / ');

  return [administration, { label: label || rest, disabled: true }];
}
